import { defaults } from 'react-chartjs-2';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { toast } from 'react-toastify';

import store from '@store/store';

import AppRoutes from '@/routes/AppRoutes.js';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '@assets/styles/main.scss';

toast.configure({ autoClose: 3500 });
defaults.font.family = 'Inter';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<Provider store={store}>
		<AppRoutes />
	</Provider>
);
